<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/400.min.svg"
    alt="400"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIcon400',
})
</script>
